<template>
  <v-app id="inspire" :dark="darkmode">
    <v-loading ref="loading"></v-loading>
    <transition name="page" mode="out-in">
      <component v-if="layout" :is="layout"></component>
    </transition>
  </v-app>
</template>


<style>
  a{
  text-decoration:none!important
}
  .tile {
    margin: 5px;
    border-radius: 4px;

  }
  .tile>a{
    text-decoration:none;
  }
  .tile>.v-list__tile--active{

    background: #eee; /* Old browsers */

  }

  .theme--light .v-navigation-drawer .v-list__tile,
  .v-navigation-drawer .v-list__tile {
    color: inherit !important;
  }
  .theme--light .v-navigation-drawer .v-list__tile--active {
    color: #1976D2 !important;
  }

@media print {
  @page {
    size: A4;
  }


  /* @page {
    size: A4;
  }
  body * {
    visibility: hidden;
  }

  #printer-content,
  #printer-content * {
    visibility: visible;
  } */

  /* #printer-content {
    position: absolute;
    left: 0;
    top: 0;

  } */
  .noprint {
    display: none;
  }
}
</style>


<script>
import Loading from './Loading'
import { mapGetters } from 'vuex'

// Load layout components dynamically.
const requireContext = require.context('../layouts', false, /.*\.vue$/)

const layouts = requireContext.keys()
  .map(file =>
    [file.replace(/(^.\/)|(\.vue$)/g, ''), requireContext(file)]
  )
  .reduce((components, [name, component]) => {
    components[name] = component
    return components
  }, {})

export default {

  components: {
    'v-loading': Loading
  },

  metaInfo () {
    const { appName } = window.config

    return {
      title: appName,
      titleTemplate: `%s · ${appName}`
    }
  },

  data: () => ({
    layout: null,
    defaultLayout: 'default'
  }),

  computed: {
    ...mapGetters({
      darkmode: 'settings/DARKMODE'
    })
  },

  mounted () {
    this.$loading = this.$refs.loading
  },

  methods: {
    /**
     * Set the application layout.
     *
     * @param {String} layout
     */
    setLayout (layout) {
      if (!layout || !layouts[layout]) {
        layout = this.defaultLayout
      }

      this.layout = layouts[layout]
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/App.vue